module.exports = __webpack_public_path__ + "static/mopfloorcheck-logo-cef23d15d027807c20a37f98bbfbf1e8.png";